/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import 'date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../../../../features/notificationSlice';

import {
  StyledKeyboardTimePicker,
  StyledKeyboardDatePicker,
} from './DateTimePicker.styled';

export default function DateTimePicker(props) {
  const { setTimeData, labelTitle, labelSelect, isDisabled } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    startTime: new Date(new Date().getTime() - 3600000),
    endTime: Date.now(),
  });
  // const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    const { startTime, endTime } = state;
    setTimeData({});
    if (startTime > new Date() || endTime > new Date()) {
      dispatch(
        enqueueSnackbar({
          message: t('ErrorTimeFuture'),
          options: {
            variant: 'error',
          },
        })
      );
    } else if (startTime > endTime) {
      dispatch(
        enqueueSnackbar({
          message: t('ErrorStartTimeMoreThanEndTime'),
          options: {
            variant: 'error',
          },
        })
      );

    } else if (
      new Date(endTime).getTime() - new Date(startTime).getTime() >
      6 * 3600000
    ) {
      dispatch(
        enqueueSnackbar({
          message: t('ErrorPeriodTime'),
          options: {
            variant: 'error',
          },
        })
      );
      
    } else {
      setTimeData(state);
    }
  }, [state]);

  const handleStartTime = (date) => {
    setState({
      ...state,
      startTime: date,
    });
  };
  const handleEndTime = (date) => {
    setState({
      ...state,
      endTime: date,
    });
  };
  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <strong style={{ width: 32 }}>{labelTitle.from}:</strong>
        <Grid container justify='space-around'>
          <StyledKeyboardDatePicker
            format='dd/MM/yyyy'
            margin='normal'
            id='date-picker-inline-1'
            label={labelSelect.date}
            value={state.startTime}
            onChange={handleStartTime}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            disableFuture
            disabled={isDisabled}
          />
          <StyledKeyboardTimePicker
            margin='normal'
            id='time-picker-1'
            label={labelSelect.time}
            value={state.startTime}
            onChange={handleStartTime}
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
            disabled={isDisabled}
          />
        </Grid>
      </MuiPickersUtilsProvider>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <strong style={{ width: 32 }}>{labelTitle.to}:</strong>
        <Grid container justify='space-around'>
          <StyledKeyboardDatePicker
            format='dd/MM/yyyy'
            margin='normal'
            id='date-picker-inline-2'
            label={labelSelect.date}
            value={state.endTime}
            onChange={handleEndTime}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            disableFuture
            disabled={isDisabled}
          />
          <StyledKeyboardTimePicker
            margin='normal'
            id='time-picker-2'
            label={labelSelect.time}
            value={state.endTime}
            onChange={handleEndTime}
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
            disabled={isDisabled}
          />
        </Grid>
      </MuiPickersUtilsProvider>
    </>
  );
}
